{
  "exitDemoButton": "Esci dalla demo",
  "exploreTheAppInDemoMode": "Esplora l'app FarmHQ utilizzando una fattoria dimostrativa:",
  "indicatorText": {
    "isEnabled": "Modalità demo"
  },
  "isActiveText": "Modalità demo attiva",
  "loadDemoButton": "Carica demo",
  "permissionDenied": "Questa funzione è disattivata in modalità demo.",
  "toasts": {
    "isEnabled": "Modalità demo abilitata"
  },
  "tryTheDemo": "Prova la demo",
  "warnings": {
    "someFeaturesDisabled": "Questa è una demo dell'app FarmHQ. Alcune funzionalità sono disabilitate."
  }
}
